import React from 'react';

const DappStoreButton = () => {
    return (
        <div className={'store_button_wrapper'}>
            <button
                className={'store_button'}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <rect x="15.5555" width="4.44444" height="4.44444" fill="#000034"/>
                    <rect x="7.19983" y="0.400391" width="4" height="4" fill="#000034"/>
                    <rect x="11.1111" y="4.44336" width="4.44444" height="4.44444" fill="#000034"/>
                    <rect x="15.5997" y="8.79883" width="4" height="4" fill="#000034"/>
                    <rect x="11.8518" y="14.0762" width="2.96296" height="2.96296" fill="#000034"/>
                    <rect x="8.14819" y="17.7773" width="2.22222" height="2.22222" fill="#000034"/>
                    <rect x="7.40674" y="9.62891" width="2.96296" height="2.96296" fill="#000034"/>
                    <rect x="3.70374" y="14.0762" width="2.22222" height="2.22222" fill="#000034"/>
                    <rect y="17.7773" width="1.48148" height="1.48148" fill="#000034"/>
                    <rect x="2.96301" y="5.18555" width="2.96296" height="2.96296" fill="#000034"/>
                    <rect y="10.3711" width="2.22222" height="2.22222" fill="#000034"/>
                </svg>
                <div className={'store_button_titles'}>
                    <span className={'store_button_titles_action'}>Download on Coldware's</span>
                    <span className={'store_button_titles_store'}>dApp Store</span>
                </div>
            </button>
        </div>
    );
};

export default DappStoreButton;